import { useField } from 'formik'
import { Checkbox, P } from '@farewill/ui'
import { PRODUCTS } from 'utils/enums'

const FeatureCheckbox = ({ label, name }: { label: string; name: string }) => {
  const [field] = useField({ name, type: 'checkbox' })
  return <Checkbox label={label} size="S" {...field} />
}

const CaseFeatureFilters = ({ product }: { product: string }) => {
  return (
    <>
      <P strong margin={[0, 0, 'XS']} size="S">
        Features
      </P>
      {product === PRODUCTS.PROBATE && (
        <>
          <FeatureCheckbox label="Priority cases" name="isPriority" />
          <FeatureCheckbox label="Tasks needing help" name="helpNeeded" />
          <FeatureCheckbox
            label="Not NewLaw referral"
            name="hideNewLawReferrals"
          />
        </>
      )}

      {product === PRODUCTS.FUNERAL && (
        <>
          <FeatureCheckbox label="Difficult case" name="isDifficult" />
          <FeatureCheckbox
            label="Green / form 6 pending"
            name="hasGreenFormPending"
          />
          <FeatureCheckbox
            label="Prepare paperwork"
            name="hasPaperworkPending"
          />
          <FeatureCheckbox label="Feedback pending" name="hasFeedbackPending" />
          <FeatureCheckbox
            label="< 7 days until service"
            name="hasServiceWithinSevenDays"
          />
          <FeatureCheckbox
            label="> 6 days without contact"
            name="hasSixDaysWithoutContact"
          />
        </>
      )}

      {product === PRODUCTS.WILL && (
        <>
          <FeatureCheckbox label="Urgent case" name="isUrgent" />
          <FeatureCheckbox label="Tasks needing help" name="helpNeeded" />
        </>
      )}
    </>
  )
}

export default CaseFeatureFilters
